import React from 'react'
import { useDisclosure } from '@chakra-ui/react'

export const ModalController = ({ modal, children, ...props }) => {
  const { isOpen, onOpen, onClose } = useDisclosure()

  return (
    <>
      {React.cloneElement(modal, { isOpen, onClose })}
      {children({ open: onOpen, close: onClose })}
    </>
  )
}

export default ModalController
